module.exports = __webpack_public_path__ + "img/canpay-logo-1.14f0b96d.png";